module.exports = __webpack_public_path__ + "pin_red_dot.bd523e.png";